<div class="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col"
  style="width: calc(100vw - 80px); height: calc(100vh - 80px); max-width: 1400px;">

  <!-- Header -->
  <div class="px-6 py-4 border-b border-gray-100 bg-gray-50 flex items-center justify-between shrink-0">
    <div class="flex items-center gap-5">
      <h2 class="font-bold text-lg text-gray-800">New Project</h2>
      <div class="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5">
        <button type="button" (click)="goToStep1()"
          class="px-4 py-1.5 rounded-md text-xs font-bold transition-all cursor-pointer"
          [class.bg-white]="currentStep === 1" [class.shadow-sm]="currentStep === 1"
          [class.text-gray-800]="currentStep === 1" [class.text-gray-500]="currentStep !== 1">
          1. Details
        </button>
        <button type="button" (click)="goToStep2()" [disabled]="!canGoToStep2()"
          class="px-4 py-1.5 rounded-md text-xs font-bold transition-all"
          [class.bg-white]="currentStep === 2" [class.shadow-sm]="currentStep === 2"
          [class.text-gray-800]="currentStep === 2" [class.text-gray-500]="currentStep !== 2"
          [class.opacity-40]="!canGoToStep2()" [class.cursor-pointer]="canGoToStep2()"
          [class.cursor-not-allowed]="!canGoToStep2()">
          2. Phases
        </button>
      </div>
    </div>
    <button (click)="close.emit()"
      class="w-8 h-8 rounded-lg hover:bg-gray-200 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors cursor-pointer">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Form -->
  <form (ngSubmit)="onSubmit()" #projectForm="ngForm" class="flex flex-col flex-1 overflow-hidden">

    <!-- ═══════════ STEP 1: Project Details ═══════════ -->
    @if (currentStep === 1) {
    <div class="flex-1 flex items-start justify-center overflow-y-auto p-10">
      <div class="w-full max-w-xl flex flex-col gap-7">

        <!-- Project Name -->
        <div class="flex flex-col gap-2">
          <label for="projectName" class="text-sm text-gray-700 font-semibold">Project Name <span class="text-red-500">*</span></label>
          <input type="text" id="projectName" name="projectName" required [(ngModel)]="projectData.projectName"
            class="border border-gray-300 rounded-lg p-3.5 focus:ring-2 focus:ring-blue-500 outline-none placeholder-gray-400 transition-shadow text-sm"
            placeholder="Enter project name" autofocus />
        </div>

        <!-- Tenant -->
        <div class="flex flex-col gap-2">
          <label for="tenantId" class="text-sm text-gray-700 font-semibold">Tenant <span class="text-red-500">*</span></label>
          @if(tenants.length === 0) {
          <div class="border border-amber-300 bg-amber-50 rounded-lg p-3 text-sm text-amber-700">
            No tenants available. Please create one in Admin first.
          </div>
          } @else {
          <div class="relative">
            <select id="tenantId" name="tenantId" required [(ngModel)]="projectData.tenantId"
              class="w-full border border-gray-300 rounded-lg p-3.5 pr-10 focus:ring-2 focus:ring-blue-500 outline-none bg-white cursor-pointer transition-shadow appearance-none text-sm">
              @for(tenant of tenants; track tenant.id) {
              <option [value]="tenant.id">{{ tenant.name }}</option>
              }
            </select>
            <div class="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none text-gray-500">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
          }
        </div>

        <!-- Status -->
        <div class="flex flex-col gap-2">
          <label for="projectStatus" class="text-sm text-gray-700 font-semibold">Status</label>
          <div class="relative">
            <select id="projectStatus" name="projectStatus" [(ngModel)]="projectData.status"
              class="w-full border border-gray-300 rounded-lg p-3.5 pr-10 focus:ring-2 focus:ring-blue-500 outline-none bg-white cursor-pointer transition-shadow appearance-none text-sm">
              @for(option of statusOptions; track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
              }
            </select>
            <div class="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none text-gray-500">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-5">
          <!-- Start Date -->
          <div class="flex flex-col gap-2">
            <label class="text-sm text-gray-700 font-semibold">Start Date</label>
            <kendo-datepicker preventScrollPropagation [value]="projectStartDateValue"
              (valueChange)="onProjectStartDateChange($event)" [format]="'dd/MM/yyyy'" [navigation]="true"
              [popupSettings]="{ popupClass: 'kendo-datepicker-large' }" placeholder="Select start date"
              class="w-full h-[50px]">
            </kendo-datepicker>
          </div>

          <!-- Contracted Hours -->
          <div class="flex flex-col gap-2">
            <label for="estimatedHours" class="text-sm text-gray-700 font-semibold">Contracted Hours</label>
            <input type="number" id="estimatedHours" name="estimatedHours" [(ngModel)]="projectData.estimatedHours"
              class="border border-gray-300 rounded-lg p-3.5 focus:ring-2 focus:ring-blue-500 outline-none transition-shadow placeholder-gray-400 text-sm"
              placeholder="e.g. 100" min="0" step="1" />
          </div>
        </div>
      </div>
    </div>

    <!-- Step 1 Footer -->
    <div class="px-8 py-4 border-t border-gray-100 bg-gray-50 flex items-center justify-between shrink-0">
      <button type="button" (click)="close.emit()"
        class="px-5 py-2.5 text-gray-600 font-medium hover:bg-gray-100 rounded-lg transition-colors cursor-pointer text-sm">
        Cancel
      </button>
      <button type="button" (click)="goToStep2()" [disabled]="!canGoToStep2()"
        class="px-6 py-2.5 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer text-sm flex items-center gap-2">
        Next: Phases
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
    }

    <!-- ═══════════ STEP 2: Phases ═══════════ -->
    @if (currentStep === 2) {
    <div class="flex-1 overflow-y-auto flex flex-col">

      <!-- Phase Controls Bar -->
      <div class="px-8 py-4 border-b border-gray-100 bg-white flex items-center justify-between shrink-0">
        <p class="text-sm text-gray-500">Phases for <span class="font-semibold text-gray-800">{{ projectData.projectName }}</span></p>
        <div class="flex items-center gap-3">
          <div class="relative">
            <select id="phaseModel" name="phaseModel" [(ngModel)]="selectedPhaseModelId"
              (change)="onPhaseModelChange()"
              class="border border-gray-300 rounded-lg p-2 pr-8 text-sm focus:ring-2 focus:ring-blue-500 outline-none bg-white cursor-pointer appearance-none">
              <option value="">Use template...</option>
              @for(model of phaseModels; track model.id) {
              <option [value]="model.id">{{ model.modelName }}</option>
              }
            </select>
            <div class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none text-gray-400">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
          <button type="button" (click)="addStage()"
            class="inline-flex items-center gap-1.5 px-4 py-2 bg-blue-50 text-blue-600 font-bold rounded-lg hover:bg-blue-100 transition-colors cursor-pointer text-sm">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
            Add Phase
          </button>
        </div>
      </div>

      <!-- Budget Bar -->
      @if (projectData.estimatedHours && projectData.estimatedHours > 0) {
      @let totalPhase = getTotalPhaseHours();
      @let budgetVal = projectData.estimatedHours;
      @let over = isPhaseHoursOverBudget();
      <div class="mx-8 mt-4 flex items-center gap-3 px-4 py-2.5 rounded-lg border"
        [class.bg-emerald-50]="!over" [class.border-emerald-200]="!over"
        [class.bg-red-50]="over" [class.border-red-200]="over">
        <div class="flex-1 flex items-center gap-3">
          <span class="text-sm font-semibold" [class.text-emerald-700]="!over" [class.text-red-600]="over">
            {{ totalPhase | number:'1.0-1' }}h / {{ budgetVal }}h
          </span>
          <div class="flex-1 h-1.5 rounded-full max-w-[200px]" [class.bg-emerald-100]="!over" [class.bg-red-100]="over">
            <div class="h-1.5 rounded-full transition-all" [class.bg-emerald-400]="!over" [class.bg-red-400]="over"
              [style.width.%]="totalPhase / budgetVal * 100 < 100 ? (totalPhase / budgetVal * 100) : 100"></div>
          </div>
        </div>
        @if (over) {
        <span class="text-xs font-semibold text-red-500">⚠ +{{ (totalPhase - budgetVal) | number:'1.0-1' }}h over budget</span>
        } @else {
        <span class="text-xs font-semibold text-emerald-600">{{ (budgetVal - totalPhase) | number:'1.0-1' }}h remaining</span>
        }
      </div>
      }

      <!-- Phases Table -->
      <div class="flex-1 px-8 py-4">
        @if (stages.length > 0) {
        <!-- Table Header -->
        <div class="grid grid-cols-[40px_1fr_80px_140px_140px_36px] gap-3 items-center px-4 py-2 text-[10px] font-bold text-gray-400 uppercase tracking-widest">
          <span></span>
          <span>Phase Name</span>
          <span class="text-right">Hours</span>
          <span>Start</span>
          <span>End</span>
          <span></span>
        </div>

        <!-- Phase Rows -->
        <div class="flex flex-col gap-2">
          @for(stage of stages; track $index) {
          <div class="grid grid-cols-[40px_1fr_80px_140px_140px_36px] gap-3 items-center px-4 py-2.5 bg-gray-50 rounded-xl border border-gray-100 hover:border-gray-200 transition-colors">
            <!-- Color -->
            <input type="color" [name]="'color' + $index" required [(ngModel)]="stage.color"
              class="w-8 h-8 rounded-lg cursor-pointer p-0.5 border border-gray-200 bg-white" />
            <!-- Name -->
            <input type="text" [name]="'stageName' + $index" required [(ngModel)]="stage.stageName"
              class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none bg-white font-medium"
              placeholder="Phase name" />
            <!-- Hours -->
            <input type="number" [name]="'estimatedHours' + $index" [(ngModel)]="stage.estimatedHours"
              class="w-full border border-gray-200 rounded-lg px-2.5 py-2 text-sm text-right focus:ring-2 focus:ring-blue-500 outline-none bg-white"
              min="0" step="0.5" placeholder="0" />
            <!-- Start Date -->
            <kendo-datepicker preventScrollPropagation
              [value]="stage.startDateValue || projectStartDateValue"
              (valueChange)="onStageStartDateChange($index, $event)" [min]="projectStartDateValue"
              [format]="'dd/MM/yyyy'" [navigation]="true"
              [popupSettings]="{ popupClass: 'kendo-datepicker-large' }" placeholder="Start"
              class="w-full h-[36px]">
            </kendo-datepicker>
            <!-- End Date -->
            <kendo-datepicker preventScrollPropagation
              [value]="stage.endDateValue || stage.startDateValue || projectStartDateValue"
              (valueChange)="onStageEndDateChange($index, $event)"
              [min]="stage.startDateValue || projectStartDateValue" [format]="'dd/MM/yyyy'"
              [navigation]="true" [popupSettings]="{ popupClass: 'kendo-datepicker-large' }"
              placeholder="End" class="w-full h-[36px]">
            </kendo-datepicker>
            <!-- Remove -->
            <button type="button" (click)="removeStage($index)" title="Remove"
              class="w-8 h-8 flex items-center justify-center text-gray-300 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors cursor-pointer">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>
          }
        </div>
        } @else {
        <div class="flex flex-col items-center justify-center py-16 text-center border-2 border-dashed border-gray-200 rounded-xl">
          <svg class="w-12 h-12 text-gray-200 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
          <p class="text-sm text-gray-400">No phases added yet</p>
          <p class="text-xs text-gray-300 mt-1">Click "Add Phase" or select a template</p>
        </div>
        }
      </div>
    </div>

    <!-- Step 2 Footer -->
    <div class="px-8 py-4 border-t border-gray-100 bg-gray-50 flex items-center justify-between shrink-0">
      <button type="button" (click)="goToStep1()"
        class="px-5 py-2.5 text-gray-600 font-medium hover:bg-gray-100 rounded-lg transition-colors cursor-pointer text-sm flex items-center gap-2">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
        Back
      </button>
      <div class="flex items-center gap-4">
        @if (stages.length > 0) {
        <span class="text-xs text-gray-400">{{ stages.length }} phase{{ stages.length > 1 ? 's' : '' }}
          @if (getTotalPhaseHours() > 0) { · {{ getTotalPhaseHours() | number:'1.0-1' }}h }
        </span>
        }
        <button type="submit" [disabled]="!projectForm.form.valid || isSubmitting || isPhaseHoursOverBudget()"
          class="px-6 py-2.5 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer text-sm flex items-center gap-2">
          @if(isSubmitting) {
          <span class="animate-spin inline-block h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
          }
          {{ isSubmitting ? 'Creating...' : 'Create Project' }}
        </button>
      </div>
    </div>
    }

  </form>
</div>
